import { createFileRoute } from '@tanstack/react-router'
import { bankStatementSearchSchema } from '../../../features/bank/search'
import { StatementsListPage } from '../../../features/bank/statements-list-page'

export const Route = createFileRoute('/_app/bank-statements/')({
  validateSearch: bankStatementSearchSchema,
  component: StatementsListPage,
})
